import React, { type FC } from "react";
import { useUscSelector } from "../../../../../redux/store";
import Icon from "../../../../../../shared-components/lexus/styles/atoms/Icon";
import SaveCodeCtaButton from "./SaveCodeCtaButton";
import { openSaveToMyToyotaModal } from "../../../../../../../common-deprecated/utils/postalUtils";
import { type UscTrackingLocation, trackCta } from "../../../../../utils/tracking";

type SaveToMyToyotaButtonPropsType = {
    buttonVariant: "basket-cta" | "icon-text";
    trackingLocation: UscTrackingLocation;
};

const SaveToMyToyotaButton: FC<SaveToMyToyotaButtonPropsType> = ({ buttonVariant, trackingLocation }) => {
    const vehicle = useUscSelector((state) => state.vehicle);

    const onClick = (tyCode?: string | null): void => {
        trackCta(`save-config-${vehicle.result?.product.model || ""}`, trackingLocation, vehicle.type);
        openSaveToMyToyotaModal(tyCode);
    };

    return (
        <SaveCodeCtaButton
            buttonVariant={buttonVariant}
            onClick={onClick}
            label="uscBasketCtaSave"
            icon={<Icon variant="profile" />}
        />
    );
};

export default SaveToMyToyotaButton;
